import FooterSocialMenu from './FooterSocialMenu';

export default FooterSocialMenu;
